import sweetFactoryStoreIcon from '@rewardopl/assets/logos/sweetfactorystore.svg';

import { Wrapper } from './header.styles';

import { VENDOR_BUSINESS_NAME } from '../constants';

export default function Header() {
  return (
    <Wrapper>
      <img width={170} height={170} src={sweetFactoryStoreIcon} alt={VENDOR_BUSINESS_NAME} />
    </Wrapper>
  );
}
